import React from 'react';
import FullCrossword from '../games/FullCrossword/FullCrossword';
import AdPlaceholder from '../components/AdPlaceholder';
import SeoHead from '../components/SeoHead';
import './GamePage.css';

export default function FullCrosswordPage() {
  return (
    <main className="game-page">
      <SeoHead
        title="Word Square"
        description="Daily 5×5 word square. Fill the grid so each row and column forms a valid five-letter word. Take your time, beat your best score, and save streaks when signed in."
        path="/crossword-full"
      />
      <div className="game-page-ad">
        <AdPlaceholder variant="game-top" />
      </div>
      <FullCrossword />
      <section className="game-page-card">
        <h2 style={{ marginTop: 0 }}>How the daily word square works</h2>
        <ul>
          <li>
            Fill the 5×5 grid so each row and each column is a valid five-letter
            word.
          </li>
          <li>
            The puzzle changes daily at <strong>00:00 UTC</strong> (so everyone
            gets the same puzzle worldwide).
          </li>
          <li>
            Definitions are sourced from an open dictionary (see attribution
            below the puzzle).
          </li>
        </ul>
      </section>
    </main>
  );
}
